import {
  enumColumnTables,
  enumerationsByColumn,
  reportColumnEnumerations,
} from "../utils/functionPairingUtils";
import { useMemo } from "react";
import { useGetEnumValuesForTablesQuery } from "services/reportsV3Service";

/** Returns a map from each available column's internalName to its enumerations, from /tables for native sources and run metadata for report sources. */
export const useEditorEnumerations = (availableColumns) => {
  const tables = useMemo(() => enumColumnTables(availableColumns), [
    availableColumns,
  ]);
  const { data } = useGetEnumValuesForTablesQuery(tables, {
    skip: tables.length === 0,
  });
  return useMemo(
    () => ({
      ...enumerationsByColumn(data),
      ...reportColumnEnumerations(availableColumns),
    }),
    [data, availableColumns]
  );
};
